module.exports = __webpack_public_path__ + "static/BT-desktop-16-f97cb4c0f53f228bf7972a16f4da0823.jpg";